import React from "react";
import PropTypes from "prop-types";

import Box from "@mui/material/Box";

const EASE = "cubic-bezier(0.65, 0, 0.35, 1)";

// Two slim lines (the lower one shorter) that morph into an X when `open`.
// Inherits `currentColor`, so the parent button sets the colour.
function MenuToggleIcon({ open, size }) {
  const line = {
    position: "absolute",
    left: 0,
    height: 2,
    borderRadius: 2,
    backgroundColor: "currentColor",
    transformOrigin: "center",
    transition: `top 0.25s ${EASE}, width 0.25s ${EASE}, transform 0.25s ${EASE}`,
  };
  const mid = size / 2 - 1;

  return (
    <Box aria-hidden sx={{ position: "relative", width: size, height: size, display: "block" }}>
      <Box
        component="span"
        sx={{
          ...line,
          width: size,
          top: open ? mid : size * 0.3,
          transform: open ? "rotate(45deg)" : "none",
        }}
      />
      <Box
        component="span"
        sx={{
          ...line,
          width: open ? size : size * 0.62,
          top: open ? mid : size * 0.62,
          transform: open ? "rotate(-45deg)" : "none",
        }}
      />
    </Box>
  );
}

MenuToggleIcon.defaultProps = {
  open: false,
  size: 22,
};

MenuToggleIcon.propTypes = {
  open: PropTypes.bool,
  size: PropTypes.number,
};

export default MenuToggleIcon;
